module.exports = __webpack_public_path__ + "assets/isolines-big-fit-95411476f19550aa5807306d40fc091e.png";